import { createFileRoute, redirect, notFound } from "@tanstack/react-router";

// The old /tools/* generator pages moved into the /font-generator hub. 301 each
// known slug to its new home; anything else is a genuine 404.
export const Route = createFileRoute("/tools/$slug")({
  beforeLoad: ({ params }) => {
    switch (params.slug) {
      case "fancy-fonts":
        throw redirect({ to: "/font-generator", statusCode: 301 });
      case "upside-down-text":
        throw redirect({ to: "/font-generator/$slug", params: { slug: "upside-down" }, statusCode: 301 });
      case "strikethrough-text":
        throw redirect({ to: "/font-generator/$slug", params: { slug: "strikethrough" }, statusCode: 301 });
      case "zalgo-text":
        throw redirect({ to: "/font-generator/$slug", params: { slug: "zalgo" }, statusCode: 301 });
      default:
        throw notFound();
    }
  },
});
